import { render, staticRenderFns } from "./BoxItem.vue?vue&type=template&id=7dddbd9f&scoped=true&"
import script from "./BoxItem.vue?vue&type=script&lang=js&"
export * from "./BoxItem.vue?vue&type=script&lang=js&"
import style0 from "./BoxItem.vue?vue&type=style&index=0&id=7dddbd9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dddbd9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VSelect,VSwitch,VTextField})
